// Material-ui
import { makeStyles, createStyles } from '@material-ui/core';
/** Row collapser styles */
export var rowCollapserStyles = function () { return createStyles({
    collapse: {},
    root: {},
}); };
/**
 * Row component classes styles
 */
export var useRowCollapserStyles = makeStyles(rowCollapserStyles);
//# sourceMappingURL=rowListCollapser.style.js.map